import React, { Suspense, useState, useEffect } from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import { TailSpin } from  'react-loader-spinner';
import ScrollToTop from "./helpers/scroll-top";
import RoutesHome from './routes';
import { socket, SocketContext } from './context/socket';
import InternetModal from './pages/common/internetModal';
import TechnicalModal from './pages/common/technicalModal';

function App() {
    const [showInternetModal, setShowInternetModal] = useState(false);
    const handleCloseInternetModal = () => {
        setShowInternetModal(false);
    };
    
    useEffect(() => {
        const handleOnline = () => {
            setShowInternetModal(false);
        };
        
        const handleOffline = () => {
            setShowInternetModal(true);
        };
        
        // Check initial connection status
        if (!navigator.onLine) {
            setShowInternetModal(true);
        }
        
        // Add event listeners
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        
        // Cleanup event listeners on unmount
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    useEffect(() => {
        let baseHeight = window.innerHeight;
        let keyboardOpen = false;

        const onResize = () => {
            const h = window.innerHeight;
            // keyboard opened
            if (!keyboardOpen && h < baseHeight - 100) {
                keyboardOpen = true;
                window.location.href = `uniwebview://keyboardOpen`;
            }

            // keyboard closed
            if (keyboardOpen && h >= baseHeight - 50) {
                keyboardOpen = false;
                window.location.href = `uniwebview://keyboardClose`;
            }
        };

        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    return (
        <Suspense fallback={<Spinner />}>
            <SocketContext.Provider  value={socket}>
                <img src="./images/brand/logo.png" className="default-ip-logo position-absolute d-none d-xl-block" alt="Logo" />
                <div className='mobile-view text-md-center'>
                    <div className='mobile-view-frame d-md-inline-block h-100 position-relative text-md-start'>
                        <Router>
                            <ScrollToTop />
                            <RoutesHome />
                        </Router>
                        <img src="./images/other/mobile.png" className="default-mobile-frame pe-none position-relative h-100 d-none d-md-block" alt="Mobile" />
                    </div>
                </div>
                <InternetModal show={showInternetModal} handleClose={handleCloseInternetModal} />
            </SocketContext.Provider> 
        </Suspense>
    );
}
export default App;

/*--- Spinner Component ---*/
const Spinner = () => {
    return (
        <div className="loader-wrapper position-relative w-100 vh-100">
            <div className="loader-inner position-absolute">
                <TailSpin color="#246BFD" height={80} width={80} className="mt-5" />
            </div>
        </div>
    );
};